import { Button as AntipadButton, ButtonProps } from '@/kit/antipad-ui/Button';
import { FC } from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';

export const Button: FC<ButtonProps> = (props) => {
   


    return <AntipadButton {...props}/>
}   